import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import { getPaginated } from "@/utils/api-utils";

export default {
  namespaced: true,
  state: {
    items: [],
    message: "",
    activeItems: [],
    error: {}
  },
  getters: {
    getField,
    getById(state) {
      /**
       * Return an item by ID
       * @param {int} id - The ID of the item you want returned
       * @param {string} idField (optional) - The field used when filtering by ID
       */
      return (id, idField = "id") =>
        state.items.find(item => item[idField] === id) || {};
    },
    getActiveItems(state) {
      return state.activeItems;
    },
    getItems(state) {
      return state.items;
    },
    getMessage(state) {
      return state.message;
    }
  },
  mutations: {
    updateField,
    setItems(state, payload) {
      Vue.set(state, "items", payload);
    },
    setMessage(state, payload) {
      Vue.set(state, "message", payload);
    },
    setActiveItems(state, payload) {
      Vue.set(state, "activeItems", payload);
    },
    setItem(state, payload) {
      const item = state.items.find(item => item.id === payload.id);
      if (item) {
        Object.assign(item, payload);
      }
    },
    setDetailItem(state, payload) {
      Vue.set(state, "detailItem", payload);
    },
    addItem(state, item) {
      state.items.push(item);
    }
  },
  actions: {
    getPaginated: getPaginated("/labs"),
    getClientLabs({ commit }, clientId) {
      return Vue.axios
        .get(`/labs/getClientLabs/${clientId}`)
        .then(({ data }) => {
          commit("setItems", data.labs);
          commit("setMessage", data.message);
          return data.labs || false;
        });
    },
    getFarm({ commit }, id) {
      return Vue.axios.get(`/labs/${id}`).then(({ data }) => {
        commit("setDetailItem", data.data);
        return data.success || false;
      });
    },
    getActiveLabs({ commit }) {
      // const options = {
      //   params: {
      //     is_active: "1"
      //   }
      // };
      return Vue.axios.get("/labs/getAllLabs").then(({ data }) => {
        commit("setActiveItems", data.labs);
        return data.success || false;
      });
    }
  }
};
